import * as React from 'react'
import {Box,Typography,Grid,Button} from '@mui/material'
import {useTheme,styled } from '@mui/material/styles'
import { useNavigate } from 'react-router-dom';

const StartBox = styled(Box, {
})(({ theme}) => ({
	transition: theme.transitions.create('width', {
	easing: theme.transitions.easing.sharp,
	duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
	width: 10,
	backgroundColor: '#000000'
},
'&::-webkit-scrollbar-thumb': {
	backgroundColor: '#ffffff',
	borderRadius: 10
},
background:"#100101",
minHeight:300,
justifyContent:"space-evenly",
alignItems:"center",
borderRadius:10,
maxWidth:"80%",
display:"flex",
flexDirection:"row"
})
);

const ErrorPage = ()=>{

const theme = useTheme()
const navigate = useNavigate();

function handleRedirect (){
  navigate('/login'); 
};

React.useEffect(()=>{
	setTimeout(()=>{
		handleRedirect()
	},7000)
},[])

return(
	<Grid container>
		<Grid item xs={12} sm={12} md={12} style={{height:70}}>
		</Grid>
		<Grid item xs={12} sm={12} md={12} sx={{justifyContent:"center",alignItems:"center",marginLeft:{xs:8,md:30}}}>
			<StartBox>
				<Box>
					<img width={300} height={250} src={require("../assets/404.gif")}/>
				</Box>
				<Box display="block" justifyContent="flex-start" alignItems="flex-start">
					<Typography  mb={2} ml={4} variant="h6" color="gold" fontWeight={500} sx={{fontFamily:"dinofans"}}>
						OOPS! PAGE NOT FOUND
					</Typography>
					<Typography  mb={2} mt={2} ml={4} fontWeight={400} sx={{color:"white",fontSize:12}}>
						the page you are looking for do not exists
					</Typography>
					<Button onClick={()=>{
						navigate("/login")
					}} sx={{background:"gold",color:"black",marginTop:2,marginLeft:{sm:3,md:4},height:{xs:30,md:35},fontFamily:"dinofans",fontSize:12}} variant="contained">
						Go Home
					</Button>
					<Typography  mb={2} mt={2} ml={4} fontWeight={400} sx={{color:"gold",fontSize:12}}>
						redirecting ...
					</Typography>
				</Box>
			</StartBox>
		</Grid>
		<Grid item xs={12} sm={12} md={12} style={{height:40}}>
		</Grid>
 </Grid>
)
}

export default ErrorPage